import BaseState from 'Engine/base/states/BaseState';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import EntryPoint from 'Engine/EntryPoint';
import eEventTypes from '../enums/eEventTypes';

export default class IdleState extends BaseState {

  constructor(stateData) {
    super(stateData);

    this.intervalDelay = 4000;
    this.interval = null;
  }

  start() {
    super.start();
    console.log('Finish spin after: ', (new Date() - EntryPoint.GameModel.startRequestTime));
    window.OPWrapperService.freeBetsController.updateTotalWin();
    if (!EntryPoint.GameModel.isFreeSpinsMode) {
      window.OPWrapperService.freeBetsController.show();
      window.OPWrapperService.realityCheck.blockedRealityCheck = false;
    }
    if (
      window.OPWrapperService.freeBetsController.isFirstFreeBet
      || window.OPWrapperService.freeBetsController.isLastFreeBet
      || window.OPWrapperService.realityCheck.blockedGame
    ) window.OPWrapperService.autoPlay.active = false;
    EntryPoint.GameModel.respinReelIndex = null;

    if (
      window.OPWrapperService.autoPlay.active
      && EntryPoint.GameModel.bet > EntryPoint.GameModel.balance
      && !EntryPoint.GameModel.isSpinWithoutBalanceCheck
    ) {
      window.OPWrapperService.autoPlay.active = false;
      window.OPWrapperService.showError(window.OPWrapperService.errors.INSUFFICIENT_BALANCE_CLIENT.CODE);
      return;
    } else if ((window.OPWrapperService.autoPlay.active && !EntryPoint.AutoPlaySettings.paused) || EntryPoint.GameModel.isFreeSpinsMode) {
      return this.stop();
    }
    this.interval = setInterval(() => GlobalDispatcher.dispatch(eEventTypes.EET_FIELD_IDLE), this.intervalDelay);
  }

  stop() {
    clearInterval(this.interval);
    super.stop()
  }
}
